import { CancelButton, Error, InputForm, SubmitButton } from "components";
import {
  CommerciaSignUpInput,
  CommerciaSignUpInputError,
} from "modules/user_management/commercial_user/user/state/actionType";
import { useState } from "react";

interface Formprops {
  header: string;
  loading: boolean;
  formData: CommerciaSignUpInput;
  error: CommerciaSignUpInputError;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: React.MouseEventHandler<HTMLButtonElement>;
  onClose: () => void;
  isUpdate?: boolean;
}

const CreateCommercialUserForm: React.FC<Formprops> = ({
  header,
  loading,
  formData,
  error,
  handleChange,
  handleSubmit,
  onClose,
  isUpdate
}) => {
const [selectedGender, setSelectedGender] = useState<"Male" | "Female" | "Other" | "">(() => {
  if (formData.gender === "Male" || formData.gender === "Female") {
    return formData.gender;
  } else if (formData.gender) {
    return "Other"; 
  } else {
    return ""; 
  }
});

const [customGender, setCustomGender] = useState(() => {
  if (formData.gender !== "Male" && formData.gender !== "Female" && formData.gender) {
    return formData.gender; 
  } else {
    return "";
  }
});



  return (
    <>
      <div className="px-4 pb-4">
        <h2 className="text-center text-xl font-bold">{header}</h2>
        <form className="">
          <div>
            <InputForm
              label="User name"
              value={formData.name}
              id="name"
              name="name"
              onChange={handleChange}
            />
            {error.name && <Error>{error.name}</Error>}
          </div>

          <div>
            <InputForm
              label="User Email"
              value={formData.email}
              id="email"
              name="email"
              onChange={handleChange}
            />
            {error.email && <Error>{error.email}</Error>}
          </div>

          <div>
            <InputForm
              label="Mobile No."
              value={formData.mobile_no}
              id="mobile_no"
              name="mobile_no"
              onChange={handleChange}
            />
            {error.mobile_no && <Error>{error.mobile_no}</Error>}
          </div>
          <div className="mb-4">
            <label className="block font-medium mb-1">Gender</label>
            <div className="flex gap-4">
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="gender"
                  value="Male"
                  checked={selectedGender === "Male"}
                  onChange={(e) => {
                    setSelectedGender("Male");
                    handleChange({
                      ...e,
                      target: {
                        ...e.target,
                        name: "gender",
                        value: "Male",
                      },
                    });
                  }}
                />
                Male
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="gender"
                  value="Female"
                  checked={selectedGender === "Female"}
                  onChange={(e) => {
                    setSelectedGender("Female");
                    handleChange({
                      ...e,
                      target: {
                        ...e.target,
                        name: "gender",
                        value: "Female",
                      },
                    });
                  }}
                />
                Female
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="gender"
                  value="Other"
                  checked={selectedGender === "Other"}
                  onChange={(e) => {
                    setSelectedGender("Other");
                    setCustomGender("");
                    handleChange({
                      ...e,
                      target: {
                        ...e.target,
                        name: "gender",
                        value: "",
                      },
                    });
                  }}
                />
                Other
              </label>
            </div>
            {selectedGender === "Other" && (
              <div className="mt-2">
                <input
                  type="text"
                  name="customGender"
                  placeholder="Please specify"
                  value={customGender}
                  onChange={(e) => {
                    setCustomGender(e.target.value);
                    handleChange({
                      ...e,
                      target: {
                        ...e.target,
                        name: "gender",
                        value: e.target.value,
                      },
                    });
                  }}
                  className="border border-gray-300 rounded px-2 py-2 w-2/5 text-sm"
                />
              </div>
            )}

            {error.gender && <Error>{error.gender}</Error>}
          </div>
         {!isUpdate &&  <div className="w-full grid grid-cols-2 gap-4">
            <div>
              <InputForm
                label="Password"
                value={formData.password}
                id="password"
                name="password"
                onChange={handleChange}
              />
              {error.password && <Error>{error.password}</Error>}
            </div>
            <div>
              <InputForm
                label="Confirm Password"
                value={formData.confirm_password}
                id="confirm_password"
                name="confirm_password"
                onChange={handleChange}
              />
              {error.confirm_password && <Error>{error.confirm_password}</Error>}
            </div>
          </div>}
          <div className="pt-3 flex justify-between">
            <CancelButton type="button" onClick={onClose} />
            <SubmitButton onClick={handleSubmit} loading={loading} />
          </div>
        </form>
      </div>
    </>
  );
};

export default CreateCommercialUserForm;
